import {createSelector} from "@reduxjs/toolkit";
import {userStateSelector, userStatusSelector} from "./userSlice";
import {isEmpty} from "es-toolkit/compat";

export const selectUserState = createSelector([userStateSelector], state => state);
export const selectUserDetails = createSelector([userStateSelector], state => (!isEmpty(state.data) ? state.data : {}));
export const selectUserPartnersAssigned = createSelector([userStateSelector], state => {
  if (!isEmpty(state.data)) {
    return (
      state.data?.partnersAssigned?.map(partner => ({
        partnerId: partner.partner_id,
        partnerName: partner.partnerName,
        partnerLogo: partner.partnerLogo,
        accessDecisionAt: partner.access_decision_at,
        accessRequestedAt: partner.access_requested_at,
        accessStatus: partner.access_status,
        requestedByUserId: partner.requested_by_user_id,
        showHcReports: partner.showHcReports,
        showTrucheckResult: partner.showTrucheckResult,
      })) || []
    );
  }
  return [];
});

export const selectUserStatus = createSelector([state => state.user], state => ({
  hasFailed: state.hasFailed,
  isFetching: state.isFetching,
  errorMsg: state.errorMsg,
}));
export const selectUserErrorMsg = createSelector([userStateSelector], status => status.errorMsg);
export const selectUserIsFetching = createSelector(userStateSelector, state => state.isFetching);
